<template>
    <div>
        <div class="boxbranco pacientes-internados">

            <titulo classeAwesome="fa fa-file-text-o" nome="Lista de Pacientes Admitidos" />

            <ul class="abas">
                <li :class="aba == 0 ? 'liativa' : ''" @click="aba = 0">por Unidade</li>
                <li :class="aba == 1 ? 'liativa' : ''" @click="aba = 1">por CNS</li>
            </ul>

            <fieldset class="bordas" v-if="aba == 0">
                <div class="row mt-3">
                    <div class="form-group col">
                        <label for="unidade">Unidade</label>
                        <input v-if="!usuarioGestao" class="form-control" disabled :value="usuario.unidade">
                        <multiselect
                            v-if="usuarioGestao"
                            :options="listaUnidades"
                            track-by="nomeCnes"
                            label="nomeCnes"
                            :searchable="true"
                            placeholder="Pesquise e selecione"
                            selectLabel="+"
                            deselectLabel="-" 
                            selectedLabel="selecionado"
                            v-model="unidade"
                        >

                            <span slot="noResult">Nenhum resultado encontrado.</span>
                        </multiselect>
                    </div>
                </div>
            </fieldset>

            <fieldset v-if="aba == 1">
                <div class="row mt-3">
                    <div class="form-group col">
                        <label for="cns-input">CNS</label>
                        <div class="input-group">
                            <input type="text" id="cns-input" class="form-control" v-model="cns" v-mask="'###############'">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" @click="refreshTokenCallMethod('censo_buscaCns', 'pesquisaCns')">Pesquisar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <b-alert :show="error ? true : false" variant="danger">{{error}}</b-alert>
            </fieldset>
        </div>

        <div class="boxbranco pacientes-internados-unidades mt-2 mb-4" v-if="aba == 0 && pacientesInternados.mapaLeitos">
            <unidades />
        </div>

        <div class="boxbranco pacientes-internados-unidades mt-2 mb-4" v-if="aba == 1 && pacientesInternados.pacienteInternado">
            <cns />
        </div>



    </div>
</template>

<script>
import Unidades from './unidades/Unidades.vue'
import Cns from './cns/Cns.vue'
import Titulo from '../../shared/titulo/Titulo.vue'
import { captcha } from '../../shared/mixins/captcha'

export default {
    components: {
        Titulo,
        Unidades,
        Cns
    },
    mixins: [
        captcha
    ],
    async created () {
        await this.$store.dispatch('filtro/pegaListaUnidades')
        if (!this.usuarioGestao)this.$store.dispatch('relatorios/mapaLeitos', this.usuario.cnes) 
    },
    data () {
        return {
            aba: 0,
            unidade: null,
            cns: ''
        }
    },
    computed: {
        usuario () {
            return this.$store.getters['sessao/getUsuario']
        },
        usuarioGestao () {
            return this.$store.getters['sessao/getUsuarioGestao']
        },
        listaUnidades () {
            return this.$store.getters['filtro/getListaUnidades']
        },
        pacientesInternados () {
            return this.$store.getters['relatorios/getPacientesInternados']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
        error () {
            return this.$store.getters['relatorios/getErrorCns']
        }
    },
    watch: {
        unidade (value) {
            if (!value) this.$store.commit('relatorios/setMapaLeitos', null)
            if (value) this.$store.dispatch('relatorios/mapaLeitos', value.cnes)
        },
    },
    methods: {
        pesquisaCns () {
            this.$store.dispatch('relatorios/consultarPacienteInternado', {cns: this.cns, captcha: this.token_captcha})
        }
    }
}
</script>

<style>
.pacientes-internados {
    max-width: 660px;
    width: 96%;
    margin: 0 auto;
}

.pacientes-internados-unidades {
    max-width: 1360px;
    width: 96%;
    margin: 0 auto;
}

.pacientes-internados fieldset {
    border-top: none;
}

.table th,
.table td {
  font-size: 12px!important;
  padding: 8px!important;
  vertical-align: middle!important;
}
.tcabecario {
  background-color: #f3f2f2;
}
</style>